// --- Subjects ---
export const SUBJECTS = [
    { value: 1, label: 'Moral Education / Citizenship / Values Education' },
    { value: 2, label: 'Technology / ICT / Computer Science' },
    { value: 3, label: 'Mathematics' },
    { value: 4, label: 'English Language / Literature' },
    { value: 5, label: 'Science: General Science / Biology / Chemistry / Physics' },
    { value: 6, label: 'Social Studies: History / Civics / Geography / Economics' },
    { value: 7, label: 'Art and Design' },
    { value: 8, label: 'Music' },
    { value: 9, label: 'Physical Education / Health' },
    { value: 10, label: 'Other (Please specify)' },
];


// --- Teaching Methods (Best Delivery) ---
export const TEACHING_METHODS = [
    { value: 0, label: "Lecture", description: "Students read through focused delivery of key concepts" },
    { value: 1, label: "Storytelling", description: "Students are given narratives to illustrate issues" },
    { value: 2, label: "Case Study", description: "Students go through scenario-based situations" },
    { value: 3, label: "Group Discussion", description: "Students interact in an real-time discussion with their peers" },
    { value: 4, label: "Role-Play", description: "Students simulate scenarios based on assigned roles" },
    { value: 5, label: "Journaling", description: "Students respond in a private written exercise" },
    { value: 6, label: "Polls", description: "Students answer questions and see their peer’s responses" },
    { value: 7, label: "Design Challenges", description: "Students create design projects to submit" },
    // { value: 8, label: "Others" },
];

// --- Session Formats ---
export const DELIVERY_FORMATS = [
    // 🔴 Independent E-Learning
    {
        label: "Independent E-Learning Module",
        code: "Format 1",
        group: "Independent E-Learning",
        techEnvironment: "Fully digital, self-paced via LMS or tools",
        learningGoal: "Empower learners to explore content independently and flexibly through an interactive learning system.",
        color: "red"
    },
    // 🔵 Guided Lecture / Teacher-Led Presentation
    {
        label: "Projected Lecture with Limited Student Devices",
        code: "Format 2.A",
        group: "Guided Lecture / Teacher-Led Presentation",
        techEnvironment: "Teacher-only device",
        learningGoal: "Deliver core knowledge efficiently with light interaction and basic reflection.",
        color: "blue"
    },
    {
        label: "Interactive Lecture with Student Devices",
        code: "Format 2.B",
        group: "Guided Lecture / Teacher-Led Presentation",
        techEnvironment: "Students use own devices",
        learningGoal: "Deliver core knowledge with enhanced interaction and real-time digital participation.",
        color: "blue"
    },
    // 🟡 Group-Based Collaborative Learning
    {
        label: "Analog Group Collaboration with Projected Prompts",
        code: "Format 3.A",
        group: "Group-Based Collaborative Learning",
        techEnvironment: "Teacher-only device",
        learningGoal: "Foster deep engagement through face-to-face collaboration and social learning.",
        color: "yellow"
    },
    {
        label: "Blended Group Collaboration with Student Devices",
        code: "Format 3.B",
        group: "Group-Based Collaborative Learning",
        techEnvironment: "Students use own devices",
        learningGoal: "Blend input, peer discussion, and digital collaboration to deepen conceptual understanding.",
        color: "yellow"
    },
    // 🟢 Individual Reflection and Task-Based Learning
    {
        label: "Offline Individual Reflection with Teacher Guidance",
        code: "Format 4.A",
        group: "Individual Reflection and Task-Based Learning",
        techEnvironment: "Teacher projects prompts",
        learningGoal: "Encourage independent thinking and self-expression with minimal tech dependency.",
        color: "green"
    },
    {
        label: "Digital Individual Task with Student Submission",
        code: "Format 4.B",
        group: "Individual Reflection and Task-Based Learning",
        techEnvironment: "Students use own devices",
        learningGoal: "Support deeper, personalized reflection and accountability using digital tools.",
        color: "green"
    },
    // Other
    // {
    //     label: "Other",
    //     code: "Other",
    //     group: "Other",
    //     techEnvironment: "",
    //     learningGoal: "",
    //     color: "grey"
    // }
];

// --- Tech Environments ---
export const TECH_ENVIRONMENTS = [
    { value: 1, label: "Only the teacher/instructor has a device, projecting slides or materials; learners do not have personal device access." },
    { value: 2, label: "Both learners and instructors have device access during class." },
    { value: 3, label: "Learners will have occasional access to devices (e.g., lab days), but most sessions rely on teacher-led projection." },
    { value: 4, label: "Neither teachers nor learners will use digital devices during class." },
];

// --- Sensitivities (Cultural, etc) ---
export const SENSITIVITIES = [
    { 
        value: 1, 
        label: "Faith-based or cultural values and perspectives",
        sublabel: "(e.g., Islamic, Christian, Jewish, Hindu, Buddhist, Indigenous, or other traditions)"
    },
    { value: 2, label: "Gender, identity, and inclusivity" },
    { value: 3, label: "Local laws, regulations, or policies" },
    { value: 4, label: "Parental or community sensitivities regarding controversial topics" },
    { value: 5, label: "None — no special considerations" },
    { value: 6, label: "Other" },
];

// --- Focus areas (for step with 1-3 rating) ---
export const FOCUS_FIELDS = [
    { key: "FocusProblem", label: "Understanding problems" },
    { key: "FocusSolution", label: "Exploring solutions" },
    { key: "FocusMindset", label: "Positive mindset" },
    { key: "FocusKS_F", label: "Factual knowledge & skills" },
    { key: "FocusKS_C", label: "Conceptual knowledge & skills" },
    { key: "FocusKS_P", label: "Procedural knowledge & skills" },
    { key: "FocusKS_M", label: "Metacognitive knowledge & skills" },
    { key: "FocusAB_A", label: "Attitudes" },
    { key: "FocusAB_P", label: "Perceived norms & prototypes" },
    { key: "FocusAB_I", label: "Intention & willingness" },
    { key: "FocusAB_B", label: "Behaviours & habits" },
];